import { useTranslation } from 'react-i18next';

export default function WhySection() {
  const { t } = useTranslation();

  const points = [
    { icon: 'ri-palette-line', text: t('why.point1') },
    { icon: 'ri-rocket-line', text: t('why.point2') },
    { icon: 'ri-seo-line', text: t('why.point3') },
    { icon: 'ri-global-line', text: t('why.point4') },
    { icon: 'ri-store-2-line', text: t('why.point5') }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-gray-900 mb-16">
          {t('why.title')}
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {points.map((point, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg p-6 flex items-start gap-4 hover:shadow-lg transition-all duration-300"
            >
              <div className="w-10 h-10 bg-gray-900 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className={`${point.icon} text-lg text-white`}></i>
              </div>
              <p className="text-sm font-medium text-gray-700 pt-2">
                {point.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}